import { Fill, Stroke } from 'ol/style';
import Style from "ol/style/Style";
import { BaseStyle } from "../../../../lib/layers/selectable/styling/styles";
export class DefaultParcelStyle extends BaseStyle {
    constructor() {
        super();
        this.alt = true;
        this.name = 'default';
        this.style_cache = {
            'SEARCHED_PARCELS': [
                new Style({
                    fill: new Fill({
                        color: 'rgba(60, 230, 230, 0.0)',
                    }),
                    stroke: new Stroke({
                        color: 'rgba(0, 189, 255, 0.9)',
                        width: 3,
                    }),
                }),
            ],
            'HOVERED_PARCEL': [new Style({
                    fill: new Fill({
                        color: 'rgba(93, 217, 193, 0.0)'
                    }),
                    stroke: new Stroke({
                        color: 'rgba(0, 189, 255, 1)',
                        width: 5
                    })
                }),
            ],
            'CLICKED_PARCEL': [
                new Style({
                    fill: new Fill({
                        color: 'rgba(60, 145, 230, 0.0)',
                    }),
                    stroke: new Stroke({
                        color: 'rgba(255, 165, 0, 1)',
                        width: 4,
                    }),
                    zIndex: 999999
                }),
            ]
        };
    }
    style_function(identifier, clicked, hovered) {
        return (feature) => {
            let c = clicked();
            if (Array.isArray(c) && c.includes(feature.get(identifier)))
                return this.style_cache.CLICKED_PARCEL;
            if (feature.get(identifier) === c)
                return this.style_cache.CLICKED_PARCEL;
            if (feature.get(identifier) === hovered())
                return this.style_cache.HOVERED_PARCEL;
            return this.style_cache.SEARCHED_PARCELS;
        };
    }
}
